/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Devices';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const DevicesIcon = withMuiAdapter(Base, 'Devices');
